import React, {Component} from 'react';

import Ciclo from './../api/Ciclo'; 

const ciclo = new Ciclo(); 

class SelectCiclo extends Component {
    constructor(){
        super();
        this.state = {
            listaCiclos : [],
            ultimoCiclo:''
        }
    }
    
    async componentDidMount () {

        let listadoCiclos = await ciclo.mostrar(); 
        this.setState({listaCiclos: listadoCiclos, ultimoCiclo:listadoCiclos[0]}); 

    }

    render(){
        const {ciclo, maneja, invalido, clase} = this.props; 

        const {listaCiclos} = this.state;
        
        return (

            <select className={"mb-2 select-cuerpo "+(invalido ? 'in-error' : '')+(clase!==null && clase!==undefined && clase!==""?" "+clase+" ": "")} onChange={maneja} value={ciclo} >
                <option>Seleccione</option>
                {
                    listaCiclos.map(c => {
                        return <option key={c.id} value={c.id}>{c.nombre}</option>
                    })
                }
            </select>
  
        )
    }
};

export default SelectCiclo;